<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3 pt-7">
            <v-divider/>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-if="loading_data === true">
              <v-tab  style="font-size: 18px" disabled>คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px" disabled>เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-else>
              <v-tab  style="font-size: 18px">คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px">เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-divider/>
          </div>
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0" hide-default-footer>
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.order_code }}</td>
                    <td>{{ dataDetail.item.receipt_code || '-' }}</td>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <div v-if="dataDetail.item.slip_status === 2" style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                        <div v-else style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <div style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                    </td>
                    <td>{{ dataDetail.item.created_at }}</td>
                    <td v-if="title_type === 0">
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">คำสั่งซื้อใหม่</div>
                      </div>
                      <div v-if="dataDetail.item.status === 1">
                        <div v-if="dataDetail.item.slip_status === 2" style="color: red">ชำระเงินไม่ถูกต้อง</div>
                        <div v-else style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                      </div>
                    </td>
                    <td v-else>
                      <div v-if="dataDetail.item.track_status === 1 && dataDetail.item.payment_type === 3">{{ dataDetail.item.track_number }}</div>
                      <div v-else-if="dataDetail.item.track_status === 1 && (dataDetail.item.payment_type === 1 || dataDetail.item.payment_type === 2)" style="color: grey">แทร็กกิ้ง : {{ dataDetail.item.track_number }}</div>
                      <div v-else style="color: red">ยกเลิก : {{ dataDetail.item.cancel_note }}</div>
                    </td>
                    <td class="pa-3">
                      <div v-if="dataDetail.item.status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <v-btn v-if="dataDetail.item.slip_status === 0" small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.slip_status === 1" small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="confirm_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.slip_status === 2" small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="cancel_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.track_status === 0 && dataDetail.item.payment_type === 3 && dataDetail.item.slip_status !== 2" small @click="change_trackStatus(dataDetail.item.id)" height="42" class="grad-warning-bg white--text mr-1 mb-1" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.slip_status !== 2" small @click="tracking_modal(dataDetail.item.id,dataDetail.item.delivery_type)" height="42" class="grad-warning-bg white--text mr-1 mb-1" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-btn small height="42" @click="print_envelope(dataDetail.item.order_code, dataDetail.item.delivery_type,dataDetail.item.payment_type)" class="grad-main-bg white--text ml-1 mb-1" title="พิมพ์ใบเสร็จ">
                        <v-icon>mdi-printer</v-icon>พิมพ์
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-pagination v-if="data_list.length !== 0" class="mt-4 mb-4" v-model="num_pages" :length="pages" :total-visible="7" circle color="#8cc63e"></v-pagination>
            </div>
          </div>
        </div>
        <!-- จัดส่ง -->
        <v-dialog v-model="tracking_success" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  {{ modal_track.delivery_type == 0 ? 'ยืนยันการส่งสินค้า' : 'หมายเลขแทร็กกิ้ง'}}
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1" v-if="modal_track.delivery_type != 0">
                  <v-text-field color="#86bc3a" clearable class="rounded-pill" type="text" label="กรุณากรอกหมายเลขแทร็กกิ้ง" :rules="[v => !!v || 'กรุณากรอกหมายเลขแทร็กกิ้ง']" prepend-inner-icon="mdi-truck-minus-outline" v-model="modal_track.tracking_number" hide-details="auto" outlined></v-text-field>
                </div>
                <div v-if="modal_track.delivery_type == 0">
                  คุณจัดสินค้าให้ลูกค้าเรียบร้อยแล้ว แจ้งลูกค้ามารับได้เลยใช่ไหม ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  {{ modal_track.delivery_type == 0 ? 'จัดสินค้าแล้ว' : 'ยืนยันหมายเลขแทร็กกิ้ง'}}
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- รับหน้าร้าน -->
        <v-dialog v-model="tracking_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการส่งสินค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณส่งสินค้าให้ลูกค้า ซึ่งต้องการรับที่หน้าร้านเรียบร้อยแล้วใช่ไหม ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ส่งสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- ยืนยันการรีเซ็ต -->
        <v-dialog v-model="clear_reset_lot" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form @submit.prevent="save_clear_reset_lot">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการเคลียร์ล็อตสินค้าใหม่
                </v-card-title>
                <v-btn icon class="ma-4" @click="clear_reset_lot = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณต้องการเคลียร์ล็อตสินค้าใหม่หรือไม่ ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-cancel-bg white--text mr-3" type="submit" style="font-size: 18px">
                  เคลียร์ล็อตสินค้าใหม่
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_retail_customers",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      tracking_success: false,
      tracking_save: false,
      overlay: false,
      alert_success: false,
      alert_tracking: false,
      clear_reset_lot: false,
      clear_reset_lot_id: null,
      title_type: 0,
      modal_track: {
        tracking_id: null,
        tracking_number: null,
        delivery_type: null,
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [],
      data_list: [],
      tab_menu: 0,

      pages: 1,
      num_pages: 1,
      size: 10,
      search: "",
      searchTimer: null
    }
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value)
    },
    page(type) {
      this.title_type = type
      if (this.title_type === 0) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
        this.get_data()
      }
      if (this.title_type === 2) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'รายละเอียด',
            value: '',
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
        this.get_data()
      }
    },
    get_data() {
      this.loading_data = true
      HTTP.post(`sell/retails?page=${this.num_pages}&size=${this.size}&search=${this.search}`, {
        status: this.title_type
      }).then((res) => {
            if (res.data.success === true) {
              this.loading_data = false
              this.data_list = res.data.object
              this.num_pages = parseInt(res.data.page);
              this.pages = parseInt(res.data.count_pages);
            }
          })
    },
    tracking_modal(id,delivery_type) {
      this.tracking_success = true
      this.modal_track.tracking_id = id
      this.modal_track.tracking_number = null
      this.modal_track.delivery_type = delivery_type
    },
    clear_reset_lot_modal(id){
      this.clear_reset_lot = true
      this.clear_reset_lot_id = id
    },
    save_clear_reset_lot(){
      this.overlay = true
      this.clear_reset_lot = false
      HTTP.post('sell/recreate', {
        order_id: this.clear_reset_lot_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.clear_reset_lot_id = null
          this.alert_clear_reset_lot_success = true
          setTimeout(() => this.alert_clear_reset_lot_success = false, 1000)
          this.get_data()
        }
      })
    },
    get_detail(id) {
      this.$router.push('/sell/orderretaildetail/' + id)
    },
    cancel_detail(id) {
      this.$router.push('/sell/payincorrect/' + id)
    },
    confirm_detail(id) {
      this.$router.push('/sell/confirmorderdetail/' + id)
    },
    wait_for_save() {
      if (this.$refs.update.validate()) {
        Swal.fire({
          text: 'คุณต้องการดำเนินการต่อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.tracking_success = false
            this.overlay = true
            HTTP.post('sell/trackingnumber', {
              order_id: this.modal_track.tracking_id,
              tracking_number: this.modal_track.tracking_number
            }).then((res) => {
              if (res.data.success === true) {
                this.tracking_success = false
                this.overlay = false
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 2000)
                this.page(0)
              }
              if (res.data.success === false) {
                this.tracking_success = false
                this.overlay = false
                Swal.fire({
                  title: "ไม่สามารถดำเนินการได้ !",
                  text: res.data.message,
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  this.tracking_success = false
                  this.overlay = false
                })
              }
            })
          }
        })
      }
    },
    save_data() {
      this.tracking_save = false
      this.alert_success = true
      setTimeout(() => this.alert_success = false, 2000)
      HTTP.post('', {
        id: this.modal_track.tracking_id,
        tracking_number: this.modal_track.tracking_number
      }).then((res) => {
        if (res.data.success === true) {
          this.tracking_save = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false,3000)
        }
      })
    },
    close_modal() {
      this.tracking_success = false
      this.tracking_save = false
      this.modal_track.tracking_number = ''
    },
    change_trackStatus(id) {
      Swal.fire({
        text: 'คุณต้องเปลี่ยนสถานะหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.overlay = true
          HTTP.post('sell/pickshop', {
            order_id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.alert_tracking = true
              setTimeout(() => this.alert_tracking = false,2000)
              this.page(0)
            }
            if (res.data.success === false) {
              this.overlay = false
              Swal.fire({
                title: "ไม่สามารถดำเนินการได้ !",
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.overlay = false
              })
            }
          })
        }
      })
    },
    print_envelope(order_code, delivery_type,payment_type) {
      if(delivery_type != 0) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + order_code, '_blank')
        if (payment_type != 3) {
          window.open('https://www.pharmacare-plus.com/envelope/' + order_code, '_blank')
        }
        
      }
      else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + order_code, '_blank')
      }
    },
  },
  mounted() {
    this.page(0)
  },
  watch:{
    tab_menu(){
      this.page(this.tab_menu)
      this.get_data();
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.get_data();
      }, 500);
    },
    num_pages() {
      this.get_data()
    }
  }
}
</script>

<style scoped>

</style>
